import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../store";
import {Tab} from "./Tab";
import {Paper} from "@material-ui/core"
import TabsNavigationItem from "./components/TabsNavigationItems";
import {LoggerService} from "../core/logger/LoggerService";
import {actionDeleteTab, actionSetActiveTab} from "../store/tabs/actions";
import ActiveTab from "./components/ActiveTab";
import ErrorBoundary from "../core/components/ErrorBoundary"

export interface TabViewProps {
	tabs: Tab[],
	activeTab: Tab,
}

export interface TabViewState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		tabs: state.tabs.list,
		activeTab: state.tabs.active
	};
}

class TabView extends React.Component<TabViewProps, TabViewState> {

	constructor(props: TabViewProps) {
		super(props)
	}

	componentDidMount() {
	}


	render(): React.ReactNode {

		return (
			<ErrorBoundary>
				<div className="ev-tab-view">
					<div
						className="ev-tab-view-navigation"
					>
						{this.props.tabs.map((tab) => {
							return <TabsNavigationItem key={tab.id}
													tab={tab}
													title={tab.title}
													isActive={this.isActive(tab)}
													handleDelete={this.deleteTab}
													handleSelect={this.selectTab}/>
						})}
					</div>

					<Paper className="ev-tab-content">
						<ActiveTab />
					</Paper>
				</div>
			</ErrorBoundary>
		);
	}

	private deleteTab (tab: Tab) {
		actionDeleteTab(tab)
		LoggerService.addInfo('Delete tab')
	}

	private selectTab (tab: Tab) {
		actionSetActiveTab(tab)
		LoggerService.addInfo('Set active tab')
	}

	private isActive (tab: Tab) {
		if (this.props.activeTab == null) return false
		if (this.props.activeTab.id == tab.id) return true
		return false
	}
}

export default connect(mapStateToProps)(TabView)
